// eslint-disable
import React, {FC, useEffect, useMemo, useRef} from 'react';
// eslint-disable-next-line import/no-unresolved
import {isMiniprogram} from 'common/index';

const stopPropagation = e => {
    e.stopPropagation();
    e.preventDefault();
};

interface ILaunchApp {
    extinfo?: string;
    wrapperStyle: React.CSSProperties;
    btnStyle: React.CSSProperties;
    onFail?: () => void;
}
let isInit = false;
const LaunchApp: FC<ILaunchApp> = ({extinfo, wrapperStyle, btnStyle, onFail}) => {
    const btnRef = useRef<HTMLDivElement>(null);
    const isWXBrowser =
        /micromessenger/i.test(navigator.userAgent) && !navigator.userAgent.includes('miniProgram');
    useEffect(() => {
        if (isWXBrowser || isMiniprogram()) {
            const findBtn = () => {
                const btn = btnRef.current;
                if (!btn) {
                    return setTimeout(findBtn, 80);
                }
                btn.addEventListener('launch', e => {
                    console.log('success');
                });
                btn.addEventListener('click', e => {
                    console.log(e);
                });

                btn.addEventListener('error', e => {
                    console.log('fail', e);
                    if (onFail) {
                        onFail();
                    } else {
                        const isIos = /iphone/i.test(navigator.userAgent);
                        const isAndroid = /android/i.test(navigator.userAgent);
                        if (isIos) {
                            window.location.href = 'https://itunes.apple.com/cn/app/id1643813247';
                        }
                        if (isAndroid) {
                            window.location.href =
                                'https://a.app.qq.com/o/simple.jsp?pkgname=com.ruhnn.recommend';
                        }
                    }
                });
            };
            findBtn();
            const config = () => {
                if (isInit) return;
                fetch(
                    `/combs/data/weixin/webaccess?url=${encodeURIComponent(
                        window.location.href.split('#')[0]
                    )}&ssoAppId=wxKocOA`
                )
                    .then(res => res.json())
                    .then(res => {
                        wx.config({
                            debug: false,
                            appId: res.result.appId,
                            timestamp: res.result.timestamp,
                            nonceStr: res.result.nonceStr,
                            signature: res.result.signature,
                            jsApiList: ['onMenuShareTimeline', 'onMenuShareAppMessage'],
                            openTagList: ['wx-open-launch-app'],
                        });
                        wx.ready(e => {
                            console.log('ready', e);
                            // config信息验证后会执行ready方法，所有接口调用都必须在config接口获得结果之后，config是一个客户端的异步操作，所以如果需要在页面加载时就调用相关接口，则须把相关接口放在ready函数中调用来确保正确执行。对于用户触发时才调用的接口，则可以直接调用，不需要放在ready函数中
                        });
                        wx.error(res => {
                            console.error('wxerror:', res);
                        });
                    });
            };
            config();

            isInit = true;
        }
    }, []);
    if (!isWXBrowser) return null;
    return (
        <div style={wrapperStyle} onClick={stopPropagation}>
            {/* @ts-ignore */}
            <wx-open-launch-app
                extinfo={`koc://m.koc18.com?${extinfo}`}
                ref={btnRef}
                appid="wx1bc23bcc372ea82a"
            >
                <script type="text/wxtag-template">
                    {/* eslint-disable-next-line  */}
                    <button style={btnStyle} />
                </script>
                {/* @ts-ignore */}
            </wx-open-launch-app>
        </div>
    );
};
export default LaunchApp;
